import { render } from "./WhyReason.vue?vue&type=template&id=748356c0&scoped=true"
import script from "./WhyReason.vue?vue&type=script&lang=js"
export * from "./WhyReason.vue?vue&type=script&lang=js"

import "./WhyReason.vue?vue&type=style&index=0&id=748356c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748356c0"]])

export default __exports__